import { DatePickerField } from '@sequencehq/core-components'
import { ComponentProps, FC } from 'react'

/**
 * A thin wrapper around DatePickerField for picking a schedule start / renewal
 * date. Lives at the Cube module level so it can be shared across the execute
 * quote flow and the schedule editor.
 */
export const StartDatePicker: FC<{
  isDisabled?: boolean
  startDate: Date | undefined
  onStartDateChange: (date: Date | undefined) => void
  minDate?: Date
  maxDate?: Date
  validationErrors?: { message: string }[]
  label?: string
  dataTestid?: string
  width?: ComponentProps<typeof DatePickerField>['width']
}> = ({
  isDisabled = false,
  startDate,
  onStartDateChange,
  minDate,
  maxDate,
  validationErrors,
  label = 'Start date',
  dataTestid = 'modal.executeQuote.startDate',
  width
}) => (
  <DatePickerField
    variant="new"
    isDisabled={isDisabled}
    label={label}
    placeholder="Not set"
    data-testid={dataTestid}
    value={startDate}
    onChange={onStartDateChange}
    minDate={minDate}
    maxDate={maxDate}
    validationErrors={validationErrors}
    width={width}
  />
)
